import { useNavigate } from 'react-router-dom';
import { Helpers } from '../../../utils/helpers';
import { MembershipTypeLookup } from '../../../components/membershipType/MembershipTypeLookup/MembershipTypeLookup';
import { MembershipTypeEditor } from '../MembershipTypeEditor/MembershipTypeEditor';
import useMembershipTypeSearch from './useMembershipTypeSearch';

export const MembershipTypeSearch = () => {
  const navigate = useNavigate();
  const manager = useMembershipTypeSearch();

  return (
    <>
      {Helpers.isNullOrWhiteSpace(manager.membershipTypeId) && (
        <div className="page-container mt-2">
          <div className="text-end">
            <button className="btn btn-primary" onClick={() => navigate(`/membership-types/new`)}>
              Add Membership Type
            </button>
          </div>
          <MembershipTypeLookup
            membershipTypeId={manager.membershipTypeId}
            onChange={manager.membershipTypeSelected}
          />
        </div>
      )}
      <MembershipTypeEditor membershipTypeId={manager.membershipTypeId} />
    </>
  );
};
